import { IPromoAvia } from 'widgets/avia/promotions/model'

import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { ActiveTicketBought, IPopularRoutesAvia, PromoModel } from './model'

export const MainPageAvia = {
  getPopularRoutes() {
    return clientApi.get<Response<IPopularRoutesAvia[]>>(
      '/flights/popular-routes',
    )
  },
  getPromoList() {
    return clientApi.get<Response<IPromoAvia[]>>('ads/baners')
  },
  getPromoDetails(id: string, signal?: AbortSignal) {
    return clientApi.get<Response<PromoModel>>(
      `ads/baners/${encodeURIComponent(id)}`,
      { signal },
    )
  },
  getLastTicketBought() {
    return clientApi.get<Response<ActiveTicketBought>>(
      'flights/upcoming/tickets/',
    )
  },
}
